import { sanitizeTabValue } from "@/utils/sanitizeTabValue";

/** Tab `value` for category row; optional `location` avoids collisions if multiple blocks share labels. */
export function createSearchTabValue(label: string, location?: string): string {
  const sanitizedLabel = sanitizeTabValue(label);
  return location
    ? `${sanitizedLabel}-${sanitizeTabValue(location)}`
    : sanitizedLabel;
}
